import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./BusinessesUIHelpers";

const BusinessesUIContext = createContext();

export function useBusinessesUIContext() {
  return useContext(BusinessesUIContext);
}

export const BusinessesUIConsumer = BusinessesUIContext.Consumer;

export function BusinessesUIProvider({ businessesUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    newBusinessButtonClick: businessesUIEvents.newBusinessButtonClick,
    openEditBusinessPage: businessesUIEvents.openEditBusinessPage,
    openDeleteBusinessDialog: businessesUIEvents.openDeleteBusinessDialog,
    openDeleteBusinessesDialog: businessesUIEvents.openDeleteBusinessesDialog,
    openFetchBusinessesDialog: businessesUIEvents.openFetchBusinessesDialog,
    openUpdateBusinessesStatusDialog:
    businessesUIEvents.openUpdateBusinessesStatusDialog,
  };

  return (
    <BusinessesUIContext.Provider value={value}>
      {children}
    </BusinessesUIContext.Provider>
  );
}
